import { render, staticRenderFns } from "./Delivery.vue?vue&type=template&id=7d59f5a7&scoped=true"
import script from "./Delivery.vue?vue&type=script&lang=js"
export * from "./Delivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d59f5a7",
  null
  
)

export default component.exports